<template>
  <div class="content">
    <div class="holder container">
      <div class="row mt-4">
        <div class="col-8 col-md-8 offset-2 offset-md-2" v-if="selectedDefinision">
          <div class="row" v-if="categoryList.length">
            <div class="col-12 col-md-6" v-for="category in categoryList" :key="category.key">
              <div
                @click="gotoListTemplate(selectedDefinision, category.label)"
                class="btn-custom"
              >{{ category.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import categoryDefinitions from "@/mixins/categoryDefinitions";
import { mapGetters } from "vuex";

export default {
  name: "A008Category",
  computed: {
    ...mapGetters(["appData"])
  },
  mixins: [categoryDefinitions],
  async created() {
    this.cdRaws = this.appData?.cdRaws;
    this.listDefinisions = this.cdGetDefinitions().filter(e => {
      if (e.key) {
        return e;
      }
    });

    this.keySelectedDefinision = this.$route.params.definision;

    this.selectedDefinision = this.getKeyByValue(
      this.$t("front_end.a008.mapUrl"),
      this.keySelectedDefinision
    );
    this.categoryList = this.cdGetCategorys(this.selectedDefinision).filter(
      e => {
        if (e.key) {
          return e;
        }
      }
    );
    this.clearSesisonTemplate();
  },
  data() {
    return {
      selectedDefinision: "",
      selectedCategory: 0,
      listDefinisions: [],
      categoryList: []
    };
  },
  methods: {
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    gotoListTemplate(d, c) {
      this.$store.commit("userData/SET_SELECTED", {
        definision: d,
        category: c
      });
      this.$router.push({ name: "a010" });
    },
    clearSesisonTemplate() {
      this.$store.dispatch("userData/clearSessionTemplate");
    }
  }
};
</script>
<style scoped>
.btn-custom {
  display: block;
  margin: 15px auto;
  text-align: center;
  border: 3px solid #dd0017;
  padding: 12px 0;
  width: 100%;
  color: #dd0017;
  font-size: 18px;
  cursor: pointer;
}
</style>
